import React, { Component } from 'react';
import PropTypes from 'prop-types';

import moment from 'moment';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import messages from '../../../locale/jsonMessages';
import { dateFormat } from '../../../config';

import cs from '../../commonStyle.css';
import s from '../ViewMessage.css';

const Status = (props) => {

    const label = (status) => {
        switch (status) {
            case 'inquiry':
                return <FormattedMessage {...messages.messageStatus1} />;
            case 'preApproved':
                return <FormattedMessage {...messages.messageStatus2} />;
            case 'declined':
                return <FormattedMessage {...messages.messageStatus3} />;
            case 'approved':
                return <FormattedMessage {...messages.messageStatus4} />;
            case 'pending':
                return <FormattedMessage {...messages.messageStatus5} />;
            case 'cancelledByHost':
                return <FormattedMessage {...messages.messageStatus6} />;
            case 'cancelledByGuest':
                return <FormattedMessage {...messages.messageStatus7} />;
            case 'intantBooking':
                return <FormattedMessage {...messages.bookingConfirmed} />;
            case 'confirmed':
                return <FormattedMessage {...messages.bookingConfirmed} />;
            case 'expired':
                return <FormattedMessage {...messages.messageStatus9} />;
            case 'requestToBook':
                return <FormattedMessage {...messages.requestToBook} />;
            case 'completed':
                return <FormattedMessage {...messages.inboxCompleted} />;
            case 'claimRequested':
                return <FormattedMessage {...messages.securityDepositClaimedMessage} />;
            case 'claimRefunded':
                return <FormattedMessage {...messages.securityDepositRefundedMessage} />;
            default:
                return <div></div>;
        }
    };

    const { type, createdAt } = props;
    let date = createdAt != null ? moment(parseInt(createdAt)).format('L') : '';
    return (
        <div className={cx(s.space4)}>
            <div className={cx(s.horizontalText)}>
                <span className={cx(s.textWrapper, s.statusText, 'messageThreadRTL')}>
                    <span>{label(type)}{" "}</span>
                    <span className={cs.dotCss}></span>
                    <span> {date}</span>
                </span>
            </div>
        </div>
    );
}

Status.propTypes = {
    type: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired
};

Status.defaultProps = {
    type: null,
    createdAt: null
};

export default withStyles(cs, s)(Status);
